import React, { Component, useState } from 'react';
import { connect } from 'react-redux';

import InvestorsMainPage from './InvestorsMainPage';
import ExpertiseMainPage from './ExpertiseMainPage';
import RequestMainPage from './RequestMainPage';
import DefaultMainPage from './DefaultMainPage';
import { getForms } from '../../actions';

class MainPage extends Component {
  render = () => {
    const {
      user,
      params: { type },
    } = this.props;

    switch (type) {
      case 'investors': {
        return (
          <InvestorsMainPage
            mode={this.props.mode}
            user={this.props.user}
            forms={this.props.forms}
          />
        );
      }
      case 'expertise': {
        return (
          <ExpertiseMainPage
            mode={this.props.mode}
            user={this.props.user}
            forms={this.props.forms}
          />
        );
      }
      case 'requests': {
        return (
          <RequestMainPage
            mode={this.props.mode}
            user={this.props.user}
            forms={this.props.forms}
            getForms={this.props.getForms}
          />
        );
      }
      default: {
        return (
          <DefaultMainPage
            mode={this.props.mode}
            user={this.props.user}
            forms={this.props.forms}
          />
        );
      }
    }
  };
}

function mapStateToProps(state) {
  return {
    mode: state.forms.mode,
    user: state.forms.user,
    forms: state.forms.forms,
  };
}

const mapDispatchToProps = dispatch => ({
  getForms: ({ page, pagesize, formKind, filters }) =>
    dispatch(getForms({ page, pagesize, formKind, filters })),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);
